import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';

import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
//import { ContextMenuModule } from "ngx-contextmenu";
//import { TextMaskModule } from "angular2-text-mask";

import { UtilsModule } from 'app/shared/utils/utils.module';

import { ValidationModule } from 'app/validation/validation.module';
import { ValidationMessage } from 'app/validation/ValidationMessage';

import { AppBasicTableComponent } from './basic';
import { AppDatatableEventsCellBubble } from './directives';
import { AppDatatableColumnSelectorComponent } from './column-selector';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    UtilsModule,
    ValidationModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    //ContextMenuModule.forRoot({
    //  autoFocus: true
    //}),
    //TextMaskModule
  ],
  
  declarations: [ 
    AppBasicTableComponent,
    AppDatatableEventsCellBubble,
    AppDatatableColumnSelectorComponent
  ],
  exports: [ 
    AppBasicTableComponent,
    AppDatatableEventsCellBubble,
    AppDatatableColumnSelectorComponent
  ],
  providers: [
  ]
})
export class AppDatatableModule { }



// WEBPACK FOOTER //
// ./src/app/shared/datatable/app-datatable.module.ts